<template>
  <div class="home">
    <!-- 轮播组件 -->
    <binner-one-item :text="binnerText"></binner-one-item>

    <!-- 一楼组件 -->
    <title-item :title="titleList[0]"></title-item>
    <floor-one-item></floor-one-item>

    <!-- 三楼组件 -->
    <about-item></about-item>

    <!-- 四楼组件 -->
    <title-item :title="titleList[3]"></title-item>
    <floor-four-item></floor-four-item>

    <!-- 五楼组件 -->
    <floor-five-item></floor-five-item>

    <!-- 七楼组件 -->
    <title-item :title="titleList[6]"></title-item>
    <floor-seven-item></floor-seven-item>

  </div>
</template>

<script>
// @ is an alias to /src
import data from "@/data/index.json";

import floorOneItem from "@/components/indexItem/floor-1-Item.vue";
import aboutItem from "@/components/aboutItem.vue";
import floorFourItem from "@/components/indexItem/floor-4-Item.vue";
import floorFiveItem from "@/components/indexItem/floor-5-Item.vue";
import floorSevenItem from "@/components/indexItem/floor-7-Item.vue";

export default {
  name: "home",
  components: {
    floorOneItem,
    aboutItem,
    floorFourItem,
    floorFiveItem,
    floorSevenItem
  },
  data() {
    return {
      binnerText: data.binnerText,
      titleList: data.titleList,
      floor1Data: data.floor1Data
    };
  },
  created() {
    this.$store.commit("headerStyle", "t");
  }
};
</script>
